window.WB.AppConfig = function ($httpProvider, $logProvider, _Config) {
    $httpProvider.interceptors.push('HMACInterceptor');
    $httpProvider.interceptors.push('RequestIdHeaderInterceptor');
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.headers.common['Accept'] = 'application/json, text/plain, */*';
    if ((_Config.Environment || window._config.Environment) !== 'Development') {
        $logProvider.debugEnabled(false);
    }
};
window.WB.AppConfig.$inject = ['$httpProvider', '$logProvider', '_Config'];

window.WB.App.config(window.WB.AppConfig);
